import { IconProps } from "../../utils/global-types/global-types";

const VerbacallIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-6 h-6"}
      {...rest}
    >
      <path
        fill="currentColor"
        d="M13.52 16.5c-.654 0-1.573-.236-2.948-1.005-1.672-.937-2.965-1.803-4.628-3.461-1.604-1.602-2.384-2.64-3.476-4.626-1.234-2.244-1.024-3.42-.788-3.922.28-.6.693-.96 1.227-1.317q.455-.298.959-.509l.092-.04c.166-.075.417-.188.736-.067.212.08.401.243.698.536.609.6 1.44 1.936 1.747 2.592.206.442.342.734.343 1.062 0 .383-.193.679-.427.998l-.13.173c-.255.335-.31.431-.274.604.075.347.632 1.381 1.547 2.294s1.92 1.435 2.268 1.51c.18.038.279-.02.624-.284q.074-.058.154-.117c.357-.265.639-.453 1.013-.453h.002c.326 0 .605.141 1.067.374.603.304 1.98 1.125 2.584 1.734.293.296.457.485.537.697.12.319.007.569-.067.736l-.04.092q-.212.502-.512.957c-.356.533-.717.945-1.32 1.225a2.26 2.26 0 0 1-.989.217"
      ></path>
    </svg>
  );
};

export default VerbacallIcon;
